import { useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { Input } from "V2.0/common/input";
import { Field, Label } from "V2.0/common/fieldset";

import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

interface PipelineDuplicateProps {
  pipeline: any;
  onClose: () => void;
  onPipelineDuplicate: (
    pipelineId: string,
    name: string,
    lifecycleCbs,
  ) => void;
}

function PipelineDuplicate(props: PipelineDuplicateProps) {
  const { pipeline, onClose, onPipelineDuplicate } = props;

  const [name, setName] = useState(`${pipeline?.name ?? "Pipeline"} (Copy)`);
  const [loading, setLoading] = useState(false);

  const handleDuplicate = () => {
    const lifecycleCbs = {
      init() {
        setLoading(true);
        message.loading("Duplicating Pipeline");
      },
      success() {
        setLoading(false);
        message.destroy();
        message.success("Pipeline duplicated");
        onClose();
      },
      error(e) {
        setLoading(false);
        message.destroy();
        showErrorToast(e, "Failed to duplicate pipeline");
      },
    };

    onPipelineDuplicate(pipeline._id, name.trim(), lifecycleCbs);
  };

  const isDuplicateDisabled = name.trim() === "" || loading;

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Duplicate Pipeline</DialogTitle>
      <DialogBody>
        <Field>
          <Label>New Pipeline Name *</Label>
          <Input
            type="text"
            autoFocus
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Field>
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDuplicate}
          disabled={isDuplicateDisabled}
          loading={loading}
        >
          Duplicate
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PipelineDuplicate;
